<template>
    <div class="ma-2">
        <!-- filter -->
        <v-row class="pt-1 px-4">
            <v-col cols="auto" class="py-2">
			    <slot name="breadcrumbs" :item="true"></slot>
		    </v-col>
        </v-row>
        <v-row class="border py-1 mx-0 rounded-lg mb-2">
            <v-col cols="2" class="px-1 py-1 d-flex align-center">
                <bee-date-input                 
                    v-model="journalsFilter.from_date"        
                    :label="$t('inputs.from-date')"
                    dense
                    hide-details
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY" 
                />
            </v-col>
            <v-col cols="2" class="px-1 py-1 d-flex align-center">
                <bee-date-input     
                    v-model="journalsFilter.to_date"                    
                    :label="$t('inputs.to-date')"
                    dense
                    hide-details
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY" 
                />
            </v-col>
            <v-col v-if="useMaterialsJournalType" cols="12" sm="4" md="2" lg="2" class="px-1 py-1 d-flex align-center">
                <v-autocomplete 
                    v-model="journalsFilter.type"
                    :items="[{name: $t('all'), value: null},...materialsJournalsTypes]"
                    item-text="name"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                    :label="$t('inputs.type')"
                />
            </v-col>
            <!-- <v-col v-if="false" cols="6" sm="4" md="2" lg="1" class="px-0" >
                <v-text-field 
                width="100"
                v-model="journalsFilter.status"
                :label="$t('inputs.invoice-no')"
                outlined
                dense
                hide-details
                />
            </v-col> -->
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1 py-1 d-flex align-center">
                <v-autocomplete 
                    v-model="journalsFilter.status"
                    :items="journalStatuses"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    :label="$t('MaterialsJournalPage.journal-status')"
                    clearable
                />
            </v-col>
            <v-col v-if="false" cols="6" sm="4" md="2" lg="2" class="px-1 py-1 d-flex align-center">
                <v-text-field 
                v-model="journalsFilter.notes"
                :label="$t('inputs.notes')"
                outlined
                dense
                hide-details
                />
            </v-col>

            <v-col></v-col>
            <v-col cols="auto " class="py-1" d-flex align-center>
                <v-btn dark color="blueGray" class="ml-3" @click="fetch()">
                    {{$t('update')}}
                </v-btn>
            </v-col>
        </v-row>
        <bee-handy-table
            ref="table"
            :headers="headers"
            :items="materialsJournals"
            :loading="loading"
            fixed-header
            dense
            zebra
            :height="$vuetify.breakpoint.height - 195"
            :items-per-page="-1"
            hide-default-footer
        >
            <!-- <template v-slot:item.is_posted="{ item }">
                <span :class="item.is_posted ? 'success--text'  : ' unpostedColor--text'">
                    {{ item.is_posted ? $t('posted') : $t('unposted') }}
                </span>
            </template> -->
            <template v-slot:item.is_posted="{ item }">
                <v-chip 
                    :color="
                    item.is_posted
                    ? 'postedColor' 
                    : 'unpostedColor'" 
                        dark
                >
                    <span class="mx-1">
                        {{
                            item.is_posted
                            ? $t('posted')
                            : $t('unposted')   
                        }}
                    </span>
                    <v-icon left dark small class="mx-1">{{ item.is_posted ? 'fa-envelope' : 'fa-envelope-open' }}</v-icon>
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-btn 
                        icon 
                        color="success" 
                        @click="redirectToMaterialJournal(item.id)"
                    >
                        <v-icon>
                            mdi-eye
                        </v-icon>
                    </v-btn>
                </div>
            </template>
    </bee-handy-table>
    </div>
</template>
<script>
import { postingPriorityType,postingType,journalStatuses, materialsJournalsTypes } from '@/helpers/enums'
import {  mapState } from 'vuex'
import { useMaterialsJournalType } from '@/configs/global'
export default {
    data() {
        return {
            type: null,
            items: [],
            loading: false,
            invoices: [],
            materialsJournalsTypes,
            postingPriorityType,
            journalStatuses,
            useMaterialsJournalType,
            postingType,
            itemId: null,
            notes: null,
            status: null,
            account: null,
            invoice_no: null,
            journalsFilter: {
                from_date: null,
                to_date: new Date().toISOString().substr(0, 10),
                type: null,
                status: null,
                notes: null
            },
            materialsJournals: []
        }
    },

    watch: {
        // '$route.query'(val) {
        //     if(val) {
        //         this.journalsFilter.type = val.type;
        //         this.journalsFilter.status = val.status;
        //         this.fetch();
        //     }
        // }
    },

    computed: {
        ...mapState({
            configs: state => state.configs.configs,
        }),
        headers() {
            return [
                {
                    text: this.$t('headers.no'),
                    name: 'invoiceNo',
                    value: 'no',
                    sortable: false
                },
                {
                    text: this.$t('headers.type'),
                    name: 'type',
                    value: 'type',
                    setValueExpr: val => val !== '-' ? this.materialsJournalsTypes.find(c => c.value === val)?.name : this.materialsJournalsTypes.find(v => v.value === 0).name,
                    sortable: false
                },
                {
                    text: this.$t('headers.state'),
                    name: 'is_posted',
                    value:'is_posted',
                    sortable: false
                },
                // {
                //     text: this.$t('headers.notes'),
                //     name: 'notes',
                //     value: 'notes',
                //     sortable: false
                // },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    width: 120,
                    sortable: false
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    width:50,
                    sortable: false
                },
            ]
        },
    },

    methods: {
        fetch() {
            this.loading = true;
            this.$store.dispatch('materialsJournals/fetchAll', {
                from_date: this.journalsFilter.from_date,
                to_date: this.journalsFilter.to_date,
                warehouses_id: '',
                type: this.journalsFilter.type,
                status: this.journalsFilter.status,
                notes: this.journalsFilter.notes,
            }).then(data => {
                this.materialsJournals = data;
                this.loading = false;
            })
        },
        redirectToMaterialJournal(id) {
            const route = this.$router.resolve({ 
                name: 'materials-journal',
                params: {id: id}
            })
            window.open(route.href, '_blank');
        }
    },
    mounted() {
        /*when come from one of invoices to show un posted invoices*/
        this.journalsFilter.type = +this.$route.query.type || [];
        this.journalsFilter.status = +this.$route.query.status || [];
        this.journalsFilter.from_date = this.configs?.financial_file?.start_date;
        this.fetch();
    }
}
</script>
<style scoped>
.border {
	border: 1px solid #f1f1f1;
    border-radius: 8px;
}
</style>